const SectionTitle = ({ text }: { text: string }) => {
  return <p className="fs-25 text-uppercase text-primary fw-700">{text}</p>;
};

export default SectionTitle;
